<div class="step-container">
  <app-otp-verification-block
    [maskedDestination]="correoOfuscado"
    [otpLength]="5"
    [expiresInSeconds]="300"
    [timerRestartKey]="resendCount"
    [errorMessage]="validateError"
    [validating]="validating"
    [showCancelButton]="true"
    [cancelLabel]="'Atrás'"
    [submitLabel]="'Verificar código'"
    [showResendLink]="true"
    hintText="Código de 5 dígitos que recibió por correo"
    (submitCode)="onVerificar($event)"
    (resend)="onReenviar()"
    (cancel)="back.emit()"
  ></app-otp-verification-block>
</div>
